import { ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ApplicationService } from '../application/application.service';
import { TableVisualizationComponent } from '../application/table-visualization/table-visualization.component';
import { TablesVisualization } from '../interfaces/tableVisualization';

@Component({
  selector: 'mic-app-hometables',
  templateUrl: './hometables.component.html',
  styleUrls: ['./hometables.component.html'],
  imports: [TableVisualizationComponent]
})
export class HometablesComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly appService = inject(ApplicationService);
  private readonly cdr = inject(ChangeDetectorRef);

  TablesVisualization: TablesVisualization[] = [];

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if (params['name'] !== 'hbi') {
        this.appService.getApplicationByName(this.route.snapshot.params['name']).subscribe((response) => {
          this.TablesVisualization = response.tableVisualizations;
          this.cdr.detectChanges();
        });
      } else {
        this.router.navigate(['../'], { relativeTo: this.route });
      }
    });
  }
}
